
import { Event }     from './event';
import { EventType } from './event.type';
import { empty }     from "@/util/util";

/**
 *
 * @class WheelEvent
 *
 * when they have rolled the mouse wheel
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class WheelEvent extends Event {

  /** normalized wheel movement */
  private _delta: number = 0;

  /** raw wheel movement */
  private _rawDelta: number = 0;

  /** relative touch/zoomm */
  private _touchScale: number = 0;

  /** standard constructor */
  constructor(krpano : any, delta: number, rawDelta: number, touchScale: number) {

    super(krpano, EventType.MOUSE_WHEEL);

    this._delta      = delta;
    this._rawDelta   = rawDelta;
    this._touchScale = touchScale;
  }

  /** normalized movement */
  delta(): number {

    return this._delta;
  }

  /** raw movement */
  rawDelta(): number {

    return this._rawDelta;
  }

  /** touch scale/zoom */
  touchScale(): number {

    return this._touchScale;
  }

}
